import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";
import * as React from "react";
import { IRootNodeFormState } from "source/app/presentation/MainPanel/Workflows/RootNodeName/Helpers/IRootNodeFormState";
import { CancelIcon } from "source/app/presentation/MainPanel/Workflows/RootNodeName/NodeDetails/CancelIcon/CancelIcon";
import { EditNodeOptions } from "source/app/presentation/MainPanel/Workflows/RootNodeName/NodeDetails/EditNodeOptions/EditNodeOptions";
import { MaxChildrenInput } from "source/app/presentation/MainPanel/Workflows/RootNodeName/NodeDetails/MaxChildrenInput/MaxChildrenInput";
import { MoveNode } from "source/app/presentation/MainPanel/Workflows/SearchNodes/MoveNode/MoveNode";
import { QuickSaveIcon } from "source/app/presentation/MainPanel/Workflows/RootNodeName/NodeDetails/QuickSave/QuickSaveIcon";
import { ShowNodeId } from "source/app/presentation/MainPanel/Workflows/RootNodeName/NodeDetails/NodeId/ShowNodeId";
import { NodeNameInput } from "source/app/presentation/MainPanel/Workflows/RootNodeName/NodeNameInput";
import { dispatchSetFunctionState } from "source/app/presentation/Shared/SharedTypes";
import { SaveIcon } from "./SaveIcon";
import * as styles from "./EditNodeDetails.css";

export function EditNodeDetails({
    state,
    loadedFormState,
    setState,
    rootNode,
}: {
    state: IRootNodeFormState;
    loadedFormState: IRootNodeFormState;
    setState: dispatchSetFunctionState<IRootNodeFormState>;
    rootNode: IWorkflowNode;
}) {
    return (
        <div>
            <NodeNameInput
                state={state}
                loadedFormState={loadedFormState}
                setState={setState}
            />
            <QuickSaveIcon
                {...{
                    state,
                    id: editNodeDetails_QuickSaveIcond_Id,
                }}
            />
            <section className={styles.nodeOptions}>
                <div className={styles.title}>Node options</div>
                <div className={styles.content}>
                    <ShowNodeId {...{ rootNode }} />
                    <MoveNode
                        rootNode={rootNode}
                        closeEditor={() => setState(loadedFormState)}
                    />
                    <div className={styles.fields}>
                        <div className={styles.field}>
                            <label
                                className={styles.fieldLabel}
                                htmlFor="editNodeOptionsInput"
                            >
                                Advanced options
                            </label>
                            <EditNodeOptions state={state} setState={setState} />
                        </div>
                        <div
                            className={`${styles.field} ${styles.shortField}`}
                        >
                            <label
                                className={styles.fieldLabel}
                                htmlFor="nodeMaxChildren"
                            >
                                Max children
                            </label>
                            <MaxChildrenInput
                                state={state}
                                setState={setState}
                            />
                        </div>
                    </div>
                    <div className={styles.footer}>
                        <SaveIcon />
                        <CancelIcon {...{ setState, loadedFormState }} />
                    </div>
                </div>
            </section>
        </div>
    );
}

export const editNodeDetails_QuickSaveIcond_Id =
    "editNodeDetails_QuickSaveIcon";
